module.exports = __webpack_public_path__ + "static/media/PM41.5394b598.png";